// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/es6.number.epsilon.js
// module id = 1804
// module chunks = 0